import { Component } from "react"

/* Icons */
import { LoadingOutlined } from '@ant-design/icons'

/* Components */
import Icon from "./Icon"


/* What each state says — the empty one speaks of the filters, because a page is empty almost
   always after a search or a filter, and the way out is to change them */
const STATES = {
    empty: {
        icon: "search",
        accent: "blue",
        title: "Ничего не найдено",
        text: "Попробуйте ещё раз, изменив фильтры или поиск"
    },
    error: {
        icon: "alert",
        accent: "red",
        title: "Ошибка сервера",
        text: "Что-то пошло не так. Попробуйте ещё раз чуть позже"
    },
    network: {
        icon: "wifiOff",
        accent: "orange",
        title: "Нет соединения",
        text: "Проверьте подключение к сети и попробуйте ещё раз"
    }
}


/* Component Data Layout — what a page shows instead of its data: the loading, the errors and the
   empty result. "onReset" adds the button which clears the filters, "empty" changes the words */
class DataLayout extends Component {

    /* One state — the picture, the words and the buttons */
    _state = key => {

        /* Fields */
        const { reload, onReset, empty } = this.props

        const state = key === "empty" && empty ? { ...STATES.empty, ...empty } : STATES[key]

        return (
            <div className={`data-layout-box ${state.accent}`}>

                <div className="data-layout-art">
                    <i className="data-layout-ring outer" />
                    <i className="data-layout-ring inner" />
                    <i className="data-layout-dot one" />
                    <i className="data-layout-dot two" />
                    <i className="data-layout-dot three" />
                    <div className="data-layout-icon">
                        <Icon name={state.icon} size={34} width={1.8} />
                    </div>
                </div>

                <h2>{state.title}</h2>
                <p>{state.text}</p>

                <div className="data-layout-buttons">

                    {key === "empty" && onReset &&
                        <div onClick={() => onReset()} className="data-layout-button primary">
                            <Icon name="refresh" size={15} width={2.2} />
                            Сбросить фильтры
                        </div>
                    }

                    {key !== "empty" && reload &&
                        <div onClick={() => reload()} className="data-layout-button primary">
                            <Icon name="refresh" size={15} width={2.2} />
                            Повторить
                        </div>
                    }

                </div>

            </div>
        )
    }

    render = () => {

        const { status, data } = this.props

        if (status === "error" || status === "network") {
            return this._state(status)
        }

        if (status === "loading") {
            return (
                <div className="data-layout-box loading">
                    <LoadingOutlined />
                </div>
            )
        }

        if (data && Array.isArray(data) && data.length === 0) {
            return this._state("empty")
        }

        return <div />
    }

}

export default DataLayout
